import { Injectable } from '@angular/core';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { ReplaySubject } from 'rxjs/ReplaySubject';
@Injectable()
export class userGioLocationService {
  private userGioLocationData = new ReplaySubject<UserGioLocation>();
  constructor() {

  }

  setserGioLocation(dataValues: UserGioLocation) {
    this.userGioLocationData.next(dataValues);
  }
  getserGioLocation() {
    return this.userGioLocationData.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/UserService/user.giolocation.service.ts